import React from 'react';
import { Flex, Typography } from '@banhala/ui-kit';

type ReviewTpoListProps = {
  tpoTypes: { sno: number; name: string }[];
};

export const ReviewTpoList: React.FC<ReviewTpoListProps> = ({ tpoTypes }) => {
  if (tpoTypes.length === 0) return null;

  return (
    <Flex.Row gap={4} flexWrap={'wrap'}>
      {tpoTypes.map((tpo, index) => (
        <Flex
          key={`tpo-${index}`}
          padding={{ horizontal: 8, vertical: 4 }}
          backgroundColor={'bg_secondary'}
          borderRadius={'small'}
        >
          <Typography type={'body4'} color={'content_secondary'}>
            {tpo.name}
          </Typography>
        </Flex>
      ))}
    </Flex.Row>
  );
};
